import Container from 'react-bootstrap/Container';
import { Navbar, Nav, Button } from 'react-bootstrap';
import '../../styles/header.css';
import { useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';

export const NavigationMusic = () => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const notFixedNavbarPaths = ["/"];
    const isNotFixed = notFixedNavbarPaths.includes(location.pathname);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Close menu on link click
    const handleLinkClick = () => {
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
    };
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isMenuOpen]);

    return (
        <Navbar variant="dark" expand="lg" className={`custom-navbar ${isNotFixed ? "" : "fixed-top"}`}>
            <Container>
                <Button className="navbar-toggler" onClick={toggleMenu} >
                    {isMenuOpen ? "\u2715" : "\u2630"}
                </Button>
                <Nav className={`nav-menu-music ${isMenuOpen ? 'open' : ''}`} id="responsive-navbar-nav">
                    <Nav.Link href="/musique/#biographie" onClick={handleLinkClick} className='btn_header'> Biographie </Nav.Link>
                    <Nav.Link href="/musique/#prestations" onClick={handleLinkClick} className='btn_header'> Prestations </Nav.Link>
                    <Nav.Link href="/musique/#enseignements" onClick={handleLinkClick} className='btn_header'> Enseignements </Nav.Link>
                    <Nav.Link href="/musique/#compositions" onClick={handleLinkClick} className='btn_header'> Compositions </Nav.Link>
                    <Nav.Link href="/musique/evenements" onClick={handleLinkClick} className='btn_header'> Evènements </Nav.Link>
                    <Nav.Link href="/musique/projets" onClick={handleLinkClick} className='btn_header'> Projets </Nav.Link>
                    <Nav.Link href="/cave" onClick={handleLinkClick} className='btn_cave'> Cave du sonneur </Nav.Link>
                </Nav>
            </Container>
        </Navbar>
    )
}